/**
 * @generated SignedSource<<ed28dc8245dcac6252ff185371506ba9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type DesignProfileStatus = "ACTIVE" | "DELETED" | "NEW" | "PENDING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProgressStatus_tradeFirm$data = {
  readonly profileStatus: DesignProfileStatus | null;
  readonly publicProfile: {
    readonly about: string | null;
    readonly address: {
      readonly country: string | null;
    } | null;
    readonly designProjectsCover: ReadonlyArray<{
      readonly status: string | null;
    } | null> | null;
    readonly email: string | null;
    readonly portfolios: ReadonlyArray<{
      readonly serviceId: string | null;
    } | null> | null;
    readonly profilePhoto: string | null;
    readonly splashPhoto: string | null;
    readonly urlLabel: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "ProgressStatus_tradeFirm";
};
export type ProgressStatus_tradeFirm$key = {
  readonly " $data"?: ProgressStatus_tradeFirm$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProgressStatus_tradeFirm">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProgressStatus_tradeFirm",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profileStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "about",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "splashPhoto",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profilePhoto",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DesignProjectCover",
          "kind": "LinkedField",
          "name": "designProjectsCover",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Address",
          "kind": "LinkedField",
          "name": "address",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "country",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PortfolioV1",
          "kind": "LinkedField",
          "name": "portfolios",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradeFirmType",
  "abstractKey": null
};
})();

(node as any).hash = "e0d6f771246029c8990d09ca8a7b8309";

export default node;
